import type { EntityId } from '@pkg/db/schema/Id'

export const getTableById = <S extends string>(entityId: EntityId<S>): S => {
  const [cTable] = entityId.split('_')
  return cTable as S
}
